import React from "react";
import CountUp from "react-countup";
import styles from "./StatsPanel.module.css";

export default function StatsPanel() {
  return (
    <div className={styles.statsPanelWrapper}>
      <div className={styles.statsImage} />
      <div className={styles.statsContent}>
        <div className={styles.statBlock}>
          <div className={styles.statNumber}>
            <CountUp end={6} duration={4} separator="," suffix="" />M
          </div>
          <div className={styles.statLabel}>Garments Per Year</div>
        </div>
        <div className={styles.statBlock}>
          <div className={styles.statNumber}>
            <CountUp end={500} duration={2} suffix="+" />
          </div>
          <div className={styles.statLabel}>Workstations</div>
        </div>
        <div className={styles.statBlock}>
          <div className={styles.statNumber}>
            <CountUp end={530} duration={2} suffix="+" />
          </div>
          <div className={styles.statLabel}>Skilled Professionals</div>
        </div>
        <div className={styles.statBlock}>
          <div className={styles.statNumber}>
            <CountUp end={8} duration={2} suffix="+" />
          </div>
          <div className={styles.statLabel}>Countries Served</div>
        </div>
      </div>
    </div>
  );
}
